import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-select2-wrapper/css/select2.min.css';
import 'react-image-lightbox/style.css';
import './assets/fonts/font-style.css';
import './assets/libs/font-awesome/css/font-awesome.min.css';
import './assets/css/style.css';
import 'react-datetime/css/react-datetime.css';
import './assets/js/internal';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import Routes from './Routes';
import Bugsnag from './helpers/bugsnag';

import './assets/css/light-theme.css';

export const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <Routes />
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
